<template>
    <b-form-row class="justify-content-md-center">
      <b-col cols="12">    
        <b-row class="text-center">
          <b-card-group>
            <b-col sm="12" md="12" lg="12" xl="3">
              <b-card>
                <h5>Set up in Seconds </h5>
                <p>Simply choose the coins you want to keep an eye on and rearrange them in the order you prefer.</p>
              </b-card>
            </b-col> 
            <b-col sm="12" md="12" lg="12" xl="3"> 
              <b-card>
                <h5> Create a Portfolio </h5>
                <p>Add the amount of coins you already own and see how well your investments are doing at a glance.</p> 
              </b-card>
            </b-col> 
            <b-col sm="12" md="12" lg="12" xl="3"> 
              <b-card >
                <h5>Watch your Crypto</h5>
                <p>Load up your saved dashboard on your phone, tablet or computer. 
                  Keep an eye on the markets wherever you go.</p>
              </b-card>
            </b-col>  
             <b-col sm="12" md="12" lg="12" xl="3"> 
             <b-card >
                <b-btn variant="outline-warning" size="lg" @click="happyClick"> Grab Happiness </b-btn>
                <br>
                Sign up for free <br>
                Add an Ethereum Wallet <br>
                Get some free Happiness
              </b-card>
            </b-col> 
          </b-card-group>
        </b-row>   
      </b-col>
    </b-form-row>
</template>

<script>

export default {
  props: {},
  data: function () {
    return {
    }
  },
  computed: {
  },
  created () {},
  methods: {
    happyClick () {
      console.log('happyclick')
      this.$emit('happyclick')
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/splash/btr-first.vue